import { render, staticRenderFns } from "./BaseContent.vue?vue&type=template&id=11912d1c&scoped=true&"
import script from "./BaseContent.vue?vue&type=script&lang=js&"
export * from "./BaseContent.vue?vue&type=script&lang=js&"
import style0 from "./BaseContent.vue?vue&type=style&index=0&id=11912d1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11912d1c",
  null
  
)

export default component.exports